import { PAYROLL_VOUCHER_RESPONSE_LABELS } from "../../utils/messages";
import {
  isPayrollDiscount,
  PayrollDiscountCandidate,
} from "../../utils/is-payroll-discount";
import { PayrollVoucherStatusBadge } from "./payroll-voucher-status-badge";
import { DivergenceWithVoucher } from "./payroll-voucher-types";
import { StatusBadge } from "../shared/status-badge";

export const PAYROLL_VOUCHER_STATUS_CELL_TEST_ID: string =
  "payroll-voucher-status-cell";

export const PAYROLL_VOUCHER_INSTALLMENTS_TEST_ID: string =
  "payroll-voucher-installments";

type PayrollVoucherStatusCellDivergence = DivergenceWithVoucher &
  PayrollDiscountCandidate;

interface PayrollVoucherStatusCellProps {
  divergence: PayrollVoucherStatusCellDivergence;
}

export function PayrollVoucherStatusCell({
  divergence,
}: PayrollVoucherStatusCellProps): JSX.Element {
  const hasVoucher: boolean = Boolean(divergence.payroll_voucher?.status);

  if (!isPayrollDiscount(divergence) && !hasVoucher) {
    return (
      <StatusBadge variant="inactive" data-testid={PAYROLL_VOUCHER_STATUS_CELL_TEST_ID}>
        {PAYROLL_VOUCHER_RESPONSE_LABELS.NOT_APPLICABLE}
      </StatusBadge>
    );
  }

  const plannedInstallments: number =
    divergence.payroll_voucher?.installments_count ?? 0;

  return (
    <span
      data-testid={PAYROLL_VOUCHER_STATUS_CELL_TEST_ID}
      className="inline-flex items-center gap-1"
    >
      <PayrollVoucherStatusBadge divergence={divergence} />
      {plannedInstallments > 0 && (
        <span
          className="text-xs text-gray-500"
          data-testid={PAYROLL_VOUCHER_INSTALLMENTS_TEST_ID}
        >
          {`${plannedInstallments}x`}
        </span>
      )}
    </span>
  );
}
